import { SVGProps } from 'react';

const DefenseAssign: FC<SVGProps<SVGSVGElement>> = (props) => (
    <svg viewBox="0 0 200 200" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
        <g>
            <circle cx="160.5" cy="44.445" r="17.5" strokeWidth="7.5" fill="none" />
            <path d="M59,146.344l90,-90" strokeWidth="7.5" strokeDasharray="3.75,15,0,0" fill="none" />
            <circle cx="40.5" cy="164.844" r="17.5" strokeWidth="7.5" fill="none" />
        </g>
    </svg>
);

export default DefenseAssign;
